<div class="fixed top-0 right-0 left-0 transition-all duration-300 z-[1000] py-1.5 px-2.5 sm:px-4 bg-white backdrop-blur-md border-b border-gray-100 shadow-xs"
    id="navbar" [ngClass]="{'is-sticky shadow-sm': isSticky}">
    <div class="container 2xl:max-w-[1320px] mx-auto px-1 sm:px-3 !my-0 !py-0">
        <div class="menu flex items-center justify-between relative flex-wrap lg:flex-nowrap">
            <!-- Brand Logo -->
            <a routerLink="/"
                class="inline-flex items-center cursor-pointer transition-transform hover:scale-105 py-0.5">
                <img src="assets/images/logo.png" alt="WBSRLM Logo"
                    class="logo-img object-contain inline-block">
            </a>

            <!-- Mobile Hamburger Button -->
            <button type="button" id="navbar-burger-menu" (click)="toggleClass()" [class.active]="classApplied"
                aria-label="Toggle navigation menu" [attr.aria-expanded]="classApplied"
                class="inline-flex flex-col justify-center items-center w-8 h-8 rounded-md p-1 text-gray-700 hover:bg-gray-100 focus:outline-none lg:hidden transition-colors">
                <span class="h-[2px] w-[20px] my-[2px] block bg-gray-800 transition-all duration-300"></span>
                <span class="h-[2px] w-[20px] my-[2px] block bg-gray-800 transition-all duration-300"></span>
                <span class="h-[2px] w-[20px] my-[2px] block bg-gray-800 transition-all duration-300"></span>
            </button>

            <!-- Desktop Navigation -->
            <div class="hidden lg:flex items-center grow justify-end gap-6">
                <ul class="navbar-nav flex items-center flex-row gap-5 xl:gap-7 m-0 p-0 list-none">
                    <li>
                        <a (click)="smoothScroll('about-us')"
                            class="nav-item cursor-pointer font-medium text-gray-700 text-sm xl:text-[15px]">
                            About Us
                        </a>
                    </li>
                    <li>
                        <a (click)="smoothScroll('mission-vision')"
                            class="nav-item cursor-pointer font-medium text-gray-700 text-sm xl:text-[15px]">
                            Mission & Vision
                        </a>
                    </li>
                    <li>
                        <a (click)="smoothScroll('training-areas')"
                            class="nav-item cursor-pointer font-medium text-gray-700 text-sm xl:text-[15px]">
                            Training List
                        </a>
                    </li>
                </ul>
                <div class="flex items-center">
                    <a routerLink="/authentication"
                        class="signin inline-flex items-center gap-1.5 text-primary-600 text-sm py-1.5 px-3.5 rounded-md transition-all font-semibold border border-primary-600 hover:text-white hover:bg-primary-600 shadow-xs">
                        <i class="material-symbols-outlined !text-[18px]">
                            login
                        </i>
                        <span>Sign in</span>
                    </a>
                </div>
            </div>

            <!-- Mobile Navigation Dropdown - Compact -->
            <div id="navbar-collapse" [class.active]="classApplied"
                class="w-full lg:hidden overflow-hidden transition-all duration-300 bg-white">
                <div class="pt-1.5 pb-1 border-t border-gray-100 mt-1">
                    <ul class="navbar-nav flex flex-col gap-0.5 p-0 m-0 list-none">
                        <li>
                            <a (click)="smoothScroll('about-us')"
                                class="mobile-nav-link flex items-center gap-2 px-2.5 py-1.5 rounded-md text-gray-700 hover:text-primary-600 hover:bg-orange-50 font-medium text-xs sm:text-sm transition-colors cursor-pointer">
                                <i class="material-symbols-outlined text-[17px] text-primary-500">info</i>
                                <span>About Us</span>
                            </a>
                        </li>
                        <li>
                            <a (click)="smoothScroll('mission-vision')"
                                class="mobile-nav-link flex items-center gap-2 px-2.5 py-1.5 rounded-md text-gray-700 hover:text-primary-600 hover:bg-orange-50 font-medium text-xs sm:text-sm transition-colors cursor-pointer">
                                <i class="material-symbols-outlined text-[17px] text-primary-500">visibility</i>
                                <span>Mission & Vision</span>
                            </a>
                        </li>
                        <li>
                            <a (click)="smoothScroll('training-areas')"
                                class="mobile-nav-link flex items-center gap-2 px-2.5 py-1.5 rounded-md text-gray-700 hover:text-primary-600 hover:bg-orange-50 font-medium text-xs sm:text-sm transition-colors cursor-pointer">
                                <i class="material-symbols-outlined text-[17px] text-primary-500">menu_book</i>
                                <span>Training List</span>
                            </a>
                        </li>
                    </ul>
                    <div class="mt-1.5 pt-1.5 border-t border-gray-100">
                        <a routerLink="/authentication" (click)="closeMenu()"
                            class="signin w-full flex items-center justify-center gap-1.5 text-white bg-primary-600 hover:bg-primary-700 text-xs sm:text-sm py-2 px-3 rounded-md transition-all font-semibold shadow-xs">
                            <i class="material-symbols-outlined !text-[17px]">
                                login
                            </i>
                            <span>Sign in</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile menu backdrop -->
@if (classApplied) {
<div class="fixed inset-0 bg-black/40 backdrop-blur-xs z-[999] lg:hidden transition-opacity" (click)="closeMenu()">
</div>
}